import BasicTable from 'Components/UI/Atoms/BasicTable'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'

import { ComprobantesFields } from './Fields'

const Comprobantes = ({ data }) => {
  return (
    <>
      <div style={{ margin: '2rem', display: 'flex', justifyContent: 'flex-start' }}>
        <InputsWithoutValidate
          key={data.receipt ? data.receipt.id : 'empty'}
          fields={ComprobantesFields(data.receipt)}
          spacing={2}
        />
      </div>
      <div style={{ display: 'flex', margin: '2rem' }}>
        <BasicTable
          col={[
            { title: 'Fecha', style: { width: '80px' } },
            { title: 'Tipo comprobante', style: { width: '100px' } },
            { title: 'Nº comprobante', style: { width: '100px' } },
            { title: 'Saldo anterior', style: { width: '100px' } },
            { title: 'Saldo actual', style: { width: '100px' } },
            { title: 'Importe a imputar', style: { width: '100px' } },
          ]}
          size="small"
          rows={data.comprobantes?.map((row) => {
            return {
              fecha: row.suc_comprobante,
              tipo_comprobante: row.tipo_comprobante,
              nro_comprobante: row.nro_comprobante,
              saldo_actual: row.saldo_actual,
              saldo_anterior: row.saldo_anterior,
              importe: `$ ${row.importe}`,
            }
          })}
        />
      </div>
    </>
  )
}

export default Comprobantes
